import React from "react";

import ColorControl from "../ui/ColorControl";

export default function OutlineControls({
  Slider,

  lineColor,
  setLineColor,

  silhouetteWidth,
  setSilhouetteWidth,

  detailStrength,
  setDetailStrength,

  shadingStrength,
  setShadingStrength,
}) {
  return (
    <>
      <ColorControl
        label="Line Color"
        value={lineColor}
        onChange={setLineColor}
      />

      <Slider
        label="Silhouette Width"
        value={silhouetteWidth}
        min={0.02}
        max={0.75}
        step={0.01}
        display={silhouetteWidth.toFixed(2)}
        onChange={setSilhouetteWidth}
      />

      <Slider
        label="Detail Strength"
        value={detailStrength}
        min={0}
        max={10}
        step={0.1}
        display={detailStrength.toFixed(1)}
        onChange={setDetailStrength}
      />

      <Slider
        label="Shading Strength"
        value={shadingStrength}
        min={0}
        max={1}
        step={0.01}
        display={shadingStrength.toFixed(2)}
        onChange={setShadingStrength}
      />
    </>
  );
}
